import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconStackVertical24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconStackVertical24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.5 4.5h15v2h-15zM3 4.5A1.5 1.5 0 0 1 4.5 3h15A1.5 1.5 0 0 1 21 4.5v2A1.5 1.5 0 0 1 19.5 8h-15A1.5 1.5 0 0 1 3 6.5zM19.5 11h-15v2h15zm-15-1.5A1.5 1.5 0 0 0 3 11v2a1.5 1.5 0 0 0 1.5 1.5h15A1.5 1.5 0 0 0 21 13v-2a1.5 1.5 0 0 0-1.5-1.5zm15 8h-15v2h15zM4.5 16A1.5 1.5 0 0 0 3 17.5v2A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-2a1.5 1.5 0 0 0-1.5-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconStackVertical24);
